import * as React from 'react';
import { observer } from 'mobx-react';

import { Link } from '../../primitives/link/link';
import { WebGivingMerchant } from '../../webgiving-generated';
import { WebGivingUserAction } from '../../webgiving-user-actions';
import { injectWebGivingProps, InjectableWebGivingProps, raiseAction } from '../../utils/injectable-props';
import { PaymentLabel } from '../../webgiving-generated';
import { ModalContents, ModalFooterShell, ModalHeaderShell } from '../../components/modal/modal';
import { Text } from '../../components/text';
import * as style from './crypto-modal.less';
import { classNames } from '../../../Shared/utils/classnames';
import { ButtonStyle, getBrandedButtonClass } from '../../primitives/button/button';

const ENGIVEN_TERMS_URL = 'https://www.engiven.com/terms-of-service';
const LEARN_MORE_URL = 'https://help.pushpay.com/s/knowledge/How-to-Give-using-Cryptocurrency';

export interface ICryptoModalProps {
	paymentLabel: PaymentLabel;
	webGivingMerchant: WebGivingMerchant;
	onRequestClose?: () => void;
}

@injectWebGivingProps
@observer
export class CryptoModalContent extends React.Component<ICryptoModalProps & InjectableWebGivingProps, {}> {
	public render() {
		const {
			webGivingMerchant: { MerchantCryptoLink },
			paymentLabel: { NounLowerCase, VerbLowerCase, NounPluralLowerCase, VerbPresentTenseLowerCase },
		} = this.props;

		return (
			<ModalContents>
				<ModalHeaderShell key="modal-base-header">
					<div className={style.headerContent}>
						<img
							data-pp-at-target="Engiven-logo"
							className={style.logo}
							src="../../../../Content/WebGiving/assets/images/engiven-logo.png"
							alt="engiven logo image"
						/>
					</div>
				</ModalHeaderShell>
				<ModalContents key="modal-content">
					<div className="brand-html-content">
						<p>
							<Text>
								{`We have partnered with Engiven to make it easy to ${VerbLowerCase} with cryptocurrency.`}</Text>
						</p>
						<p>
							<Text>
								{`To make your ${NounLowerCase}, click the button below to be redirected to Engiven's website, enter your ${NounLowerCase} amount and fill out the form.`}
							</Text>
						</p>
						<p>
							<Text>{`All ${NounPluralLowerCase} will be converted to USD.`}</Text>
						</p>
						<p>
							<Text>Engiven is a trusted partner of Pushpay. </Text>
							<Link
								openInNewTab={true}
								branded={true}
								acceptanceTestTargetId="Crypto learn more"
								href={LEARN_MORE_URL}
							>
								<Text>Click here </Text>
							</Link>
							<Text
							>{`to learn more about ${VerbPresentTenseLowerCase} in cryptocurrency.`}</Text>
						</p>
						<p>
							<Text>Engiven </Text>
							<Link
								openInNewTab={true}
								branded={true}
								acceptanceTestTargetId="Crypto terms and conditions"
								href={ENGIVEN_TERMS_URL}
							>
								<Text>terms and conditions </Text>
							</Link>
							<Text>apply</Text>
						</p>
					</div>
				</ModalContents>
				<ModalFooterShell key="modal-footer">
					<hr className={style.hr} />
					<Link
						className={classNames(getBrandedButtonClass(ButtonStyle.Primary), style.btn)}
						acceptanceTestTargetId="Crypto Redirect"
						branded={false}
						openInNewTab={true}
						href={MerchantCryptoLink}
						onClick={() => raiseAction(new WebGivingUserAction.LogCryptoGiving(), this.props)}
					>
						<Text>{`Make your Crypto ${NounLowerCase}`}</Text>
					</Link>
				</ModalFooterShell>
			</ModalContents>
		);
	}
}
